import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Separator } from './ui/separator';

const Contact = () => {
  return (
    <section className="py-12 md:py-16">
      <Separator className="mb-12 md:mb-16 bg-border" />

      <nav className="flex flex-wrap gap-8 md:gap-12">
        <a
          href="https://www.linkedin.com/in/alvarezmauro/"
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-1 font-sans text-base md:text-lg text-foreground hover:text-muted-foreground transition-colors duration-200"
        >
          LinkedIn
          <ArrowUpRight className="w-4 h-4 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200" />
        </a>

        <a
          href="https://x.com/morklash"
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-1 font-sans text-base md:text-lg text-foreground hover:text-muted-foreground transition-colors duration-200"
        >
          X
          <ArrowUpRight className="w-4 h-4 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200" />
        </a>

        <a
          href="https://github.com/alvarezmauro"
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-1 font-sans text-base md:text-lg text-foreground hover:text-muted-foreground transition-colors duration-200"
        >
          Github
          <ArrowUpRight className="w-4 h-4 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200" />
        </a>

        {/* Usamos el email corporativo para la ronda */}
        <a
          href="mailto:mauro@enabl.ai"
          className="group inline-flex items-center gap-1 font-sans text-base md:text-lg text-foreground hover:text-muted-foreground transition-colors duration-200"
        >
          Email
          <ArrowUpRight className="w-4 h-4 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200" />
        </a>
      </nav>

      <p className="mt-12 text-xs font-mono uppercase tracking-widest text-muted-foreground/50">
        Based in Argentina. Building software and teams globally. ©{new Date().getFullYear()}
      </p>
    </section>
  );
};

export default Contact;